import { EnrollmentStatusConstant } from "../../@types/enrollment.types";

const enrollmentStatuses = ["OPEN", "SUBMITTED", "REJECTED", "WAIVED", "CLOSED", "ACTIVE"];

export const ENROLLMENT_STATUSES = enrollmentStatuses;

const enrollmentStatus: EnrollmentStatusConstant = {
	active: "ACTIVE",
	opened: "OPENED",
	submitted: "SUBMITTED",
	rejected: "REJECTED",
	// rejected: "SUBMITTED-REJECTED",
	waived: "WAIVED",
	closed: "CLOSED"
};

export const ENROLLMENT_STATUS = enrollmentStatus;
